import classNames from 'classnames'
import React from 'react'

export interface SeparatorProps {
    className?: string
    element?: 'hr' | 'div' | 'span'
    variant?: 'slim' | 'large' | 'tiny'
    invisible?: boolean
}

export const Separator = (props: SeparatorProps): JSX.Element => {
    const { element: Element = 'div', invisible } = props

    const className: string = classNames(
        'separator',
        invisible && 'separator--invisible',
        props.variant && `separator--variant-${props.variant}`,
        props.className,
    )

    return <Element className={className} />
}
